import {
    createColumnDate,
    createColumnInput,
    createColumnSelect,
    createColumnTreeSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callUserObjective } from "../../haz/request/request.section";
import { callRequestDepartment } from "../../storage-location/request/requestor/requestor.section";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { callHazSpecies } from "../../inform/request/inform-product/inform-product.logic";
import { callDepartment, callDepartmentImport } from "../../inform/request/inform-info/inform-info.section";
import { dateDiffStr } from "../../../../utils/date";
import lodash from "lodash";
import numeral from "numeral";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.report.docType"),
            dataIndexValue: () => i18n.global.t("views.report.pass"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({ title: () => i18n.global.t("views.report.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refHazObject"),
            dataIndex: "products.refHazObject.nameTh",
            dataIndexValue: ({ record }) => {
                return record.products?.map(d => d.refHazObject?.nameTh).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            width: 300
        }),
        createColumnInput({
            title: () => i18n.global.t("model.informProduct.tradeName"),
            dataIndex: "products.tradeName",
            dataIndexValue: ({ record }) => {
                return record.products?.map(d => d.tradeName).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            width: 300
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.informProduct.refHazSpecies"),
            dataIndex: "products.refHazSpecies.value",
            dataIndexValue: ({ record }) => {
                return record.products?.map(d => d.refHazSpecies?.value).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            inputProp: () => ({ list: callHazSpecies, optLabel: "value" }),
            search: { name: "products.refHazSpecies.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.inform.refImportCheckpoint"),
            dataIndex: "refImportCheckpoint.nameTh",
            inputProp: () => ({ list: callDepartmentImport, optLabel: "nameTh" }),
            search: { visible: () => false, name: "refImportCheckpoint.id" }
        }),createColumnSelect({
            title: () => i18n.global.t("model.inform.refImportCheckpoint2"),
            dataIndex: "refImportCheckpoint2.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { visible: () => false, name: "refImportCheckpoint2.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refOperation"),
            dataIndex: "refOperation.value",
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            search: { visible: () => false, name: "refOperation.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.request.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: () => callRequestDepartment({ refRequestDocKey: "19" }),
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { visible: () => false, name: "refDepartment.id" },
            width: 200
        }),
        createColumnInput({
            title: () => i18n.global.t("model.inform.invoiceCode"),
            dataIndex: "products.invoiceCode",
            dataIndexValue: ({ record }) => record.products.map(d => d.invoiceCode).join("\r\n"),
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "center"
        }),
        createColumnDate({ title: () => i18n.global.t("views.report.docEffectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.docTimeLive"),
            // dataIndexValue: () => "1 เดือน",
            dataIndexValue: ({ record }) => dateDiffStr({ record }), sorter: false,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnDate({
            title: () => i18n.global.t("views.report.releaseDate"),
            dataIndex: "refInspection.refRelease.releaseDate",
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.report.weight"),
            dataIndex: "qty",
            dataIndexValue: ({ record }) => {
                return record.products.map(d => numeral(lodash.sum(d.productQties.map(d => d.qty || 0))).format("0,0.00")).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "right",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.report.amount"),
            dataIndex: "amount",
            dataIndexValue: ({ record }) => {
                return record.products.map(d => numeral(lodash.sum(d.productQties.map(d => d.amount || 0))).format("0,0.00")).join("\r\n")
            },
            customRender: ({ record, column }) => <pre>{column.dataIndexValue({ record })}</pre>,
            align: "right",
            width: 120,
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
